import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { SmsChartByTimeComponent } from './chart-by-time.component';
import { ChartByKeywordsComponent } from './chart-by-keywords.component';
import { MatButton } from '@angular/material/button';

export interface MatMessagingChartZoomDialogData {
  chartData: any[];
  dialogTitle: string;
  showActivityPieChart: boolean;
  chartType: 'line' | 'bar';
  chartPieType: 'pie' | 'bar';
  startDate: string;
  endDate: string;
  additionalFilter: any
}

@Component({
    selector: 'app-mat-chart-user-dialog',
    template: `
    <mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
      <app-sms-chart-by-time [data]="data.chartData" [chartType]="data.chartType" [startDate]="data.startDate" [endDate]="data.endDate" *ngIf="!data.showActivityPieChart" ></app-sms-chart-by-time>
      <app-chart-by-keywords [data]="data.chartData" [chartType]="data.chartPieType" [additionalFilter]="data.additionalFilter"></app-chart-by-keywords>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  `,
    standalone: true,
    imports: [
        CdkScrollable,
        MatDialogContent,
        NgIf,
        SmsChartByTimeComponent,
        ChartByKeywordsComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class MatMessagingChartZoomDialogComponent implements OnInit, OnDestroy {

  constructor(public dialogRef: MatDialogRef<MatMessagingChartZoomDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MatMessagingChartZoomDialogData
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
